import React from 'react';

import { bemCssModules } from '@utils';

import SandWatch from './sand_watch.svg';

import style from './Illustration.scss';

const cn = bemCssModules(style, 'Illustration');

export const Illustration: CustomFC = ({ className }) => {
  return (
    <div className={cn(null, [className])}>
      <img className={cn('img')} src="/img/wind.png" alt="wind" />
      <SandWatch className={cn('frame')} />
    </div>
  );
};

export default Illustration;
